(function() {
    'use strict';
    angular
        .module('setupApp')
        .factory('DepartmentService', DepartmentService);


    DepartmentService.$inject = ['$resource', 'authExpiredInterceptor', 'GLOBAL_URL'];

    function DepartmentService ($resource, authExpiredInterceptor, GLOBAL_URL) {
    	return $resource(GLOBAL_URL + 'api/ga/setup/:uri',{uri: '@uri'}, {
  		  'postList':   {method:'POST', isArray: true},
  		  'post':   {method:'POST'},
  		  'save': {
  			method: 'POST',
  				transformRequest: formDataObject,
  				headers: { 'Content-Type' : undefined, enctype: 'multipart/form-data'}
  			}  		  
      });
    }
    
	function formDataObject (data) {
        var fd = new FormData();
        angular.forEach(data, function(value, key) {
            fd.append(key, value);
        });
        return fd;
    }
})();
